export default __webpack_public_path__ + "static/media/meta.33b88a6b.png";